export class PdfUtils {

    static downloadPdf(file: Blob, name: string)
    {
        const link = document.createElement('a');
        const url = URL.createObjectURL(new Blob([file], { type: 'application/pdf' }));

        link.href = url;
        link.target = '_blank'
        link.download = name + '.pdf';
        link.click();
    }
}